/**
 * Parse video_pipeline `/camera/health` (std_msgs/String JSON).
 * Example: {"front":"running","gimbal":"running","thermal":"running"}
 */

export function cameraHealthString(data: unknown): string {
    if (data == null) return "";
    if (typeof data === "string") return data;
    if (typeof (data as { data?: unknown })?.data === "string") {
        return (data as { data: string }).data;
    }
    return "";
}

export function parseCameraHealthMap(data: unknown): Record<string, string> | null {
    const raw = cameraHealthString(data).trim();
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw) as unknown;
        if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return null;
        const out: Record<string, string> = {};
        for (const [key, value] of Object.entries(parsed as Record<string, unknown>)) {
            if (typeof value === "string") out[key] = value;
        }
        return out;
    } catch {
        return null;
    }
}

/** video_pipeline reports "running" or "running: …" when the pipeline is up. */
export function isCameraPipelineRunning(status: string | undefined | null): boolean {
    return typeof status === "string" && status.startsWith("running");
}

export function isGimbalCameraHealthy(data: unknown): boolean {
    const map = parseCameraHealthMap(data);
    if (!map) return false;
    return isCameraPipelineRunning(map.gimbal);
}
